import React, {Component} from "react";

export class CourseworkContainer extends Component {
    render() {
        return (
            <div>
                <h1>
                    {"Coursework"}
                </h1>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/MainPages/Coursework.js